<main id="page-auth" class="page-auth">
    <section>
        <article class="auth-box">
            <h1 translate>auth.recoverPassword.recover</h1>
            <div class="auth-box__form">
                <div class="header">
                    <img src="/assets/images/logo-ubaristi.svg" alt="Ubaristi" title="Ubaristi" class="logo">
                    <p *ngIf="!done" class="text" translate>auth.recoverPassword.completeAllFields</p>
                </div>
                <app-recover-password-form *ngIf="!done" (recover)="onRecover($event)"></app-recover-password-form>
                <app-recover-password-done *ngIf="done"></app-recover-password-done>
            </div>
        </article>
    </section>
</main>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/recover-password/recover-password.component.html